const DialogPlayerEvent = {};
export default DialogPlayerEvent;

DialogPlayerEvent.START_DIALOG = "DialogPlayerEvent.START_DIALOG";
DialogPlayerEvent.DIALOG_COMMAND = "DialogPlayerEvent.DIALOG_COMMAND";
DialogPlayerEvent.DIALOG_OPTION = "DialogPlayerEvent.DIALOG_OPTION";
DialogPlayerEvent.END_DIALOG = "DialogPlayerEvent.END_DIALOG";
DialogPlayerEvent.ENTER_DIALOG_STATE = "DialogPlayerEvent.ENTER_DIALOG_STATE";
DialogPlayerEvent.EXIT_DIALOG_STATE = "DialogPlayerEvent.EXIT_DIALOG_STATE";
DialogPlayerEvent.ENTER_DIALOG_TRANSITION = "DialogPlayerEvent.ENTER_DIALOG_TRANSITION";
DialogPlayerEvent.EXIT_DIALOG_TRANSITION = "DialogPlayerEvent.EXIT_DIALOG_TRANSITION";
DialogPlayerEvent.DIALOG_TIME_OUT = "DialogPlayerEvent.DIALOG_TIME_OUT";
DialogPlayerEvent.DIALOG_TIME_TICK = "DialogPlayerEvent.DIALOG_TIME_TICK";
DialogPlayerEvent.COMMAND_SEQUENCE_TIME_TICK = "DialogPlayerEvent.COMMAND_SEQUENCE_TIME_TICK";
DialogPlayerEvent.COMMAND_SEQUENCE_END  = "DialogPlayerEvent.COMMAND_SEQUENCE_END";